import { Inject, Injectable } from '@angular/core';
import { CacheService } from '@df/core/cache/cache';
import { DfsGlobalsService } from '../../core/dfs-globals.service';
import { NDfs } from '../../dfs.interfaces';

export interface IDfsConfigParserOptions {
    source: string;
}

@Injectable({
    providedIn: 'any'
})
export class DfsWrapParserService implements NDfs.IParser {
    /**
     * Dependencies
     */
    constructor(private cacheService: CacheService) {}

    /**
     * Returns the value from string
     */
    parse(dfsGlobalsService: DfsGlobalsService, dfs: string, rule: NDfs.IParserRule): NDfs.ICssEntry[] {
        return this.cacheService.get<NDfs.ICssEntry[]>(['dfs', 'wrapParser', dfs], () => {
            return [
                {
                    prop: 'width',
                    value: `var(--dfs-wrap-${dfs})`
                },
                {
                    prop: 'margin-right',
                    value: 'auto'
                },
                {
                    prop: 'margin-left',
                    value: 'auto'
                }
            ];
        })!;
    }
}
